<!-- This a higher order component that composes `NavItemComponent`  -->
@if (!hideIfEmpty() || nestedNavComponents().length > 0) {
  <bit-nav-item
    [text]="text()"
    [icon]="icon()"
    [route]="route()"
    [treeDepth]="treeDepth()"
    [relativeTo]="relativeTo()"
    [routerLinkActiveOptions]="routerLinkActiveOptions()"
    (mainContentClicked)="handleMainContentClicked()"
    [ariaLabel]="ariaLabel()"
    [hideActiveStyles]="parentHideActiveStyles()"
    [ariaCurrentWhenActive]="ariaCurrent()"
    [forceActiveStyles]="forceActiveStyles()"
  >
    <button
      slot="start"
      type="button"
      class="tw-ms-auto"
      [class]="!open() ? 'tw-transform tw-rotate-[-90deg]' : ''"
      bitIconButton="bwi-down-solid"
      buttonType="side-nav"
      (click)="toggle($event)"
      size="xsmall"
      [attr.aria-expanded]="open().toString()"
      [attr.aria-controls]="contentId"
      [label]="['toggleCollapse' | i18n, text()].join(' ')"
      data-testid="nav-group-collapse-arrow"
    ></button>
    <ng-container slot="end">
      <ng-content select="[slot=end]"></ng-content>
    </ng-container>
  </bit-nav-item>
  <!-- [attr.aria-controls] of the above button expects a unique ID on the controlled element -->
  @if (sideNavOpen()) {
    @if (open()) {
      <div
        [attr.id]="contentId"
        [attr.aria-label]="[text(), 'submenu' | i18n].join(' ')"
        role="group"
      >
        <ng-content></ng-content>
      </div>
    }
  }
}
